// extracted by mini-css-extract-plugin
export default {"container":"ChildEmailBodyPreview_container__SGgZV","overflowOverlay":"ChildEmailBodyPreview_overflowOverlay__E2Uq-"};